import React, { useEffect, useRef } from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => createStyles({
  frame: {
    width: '90%',
    minWidth: 300,
    maxWidth: 900,
    height: '100%',
    minHeight: 'calc(300px / 1.7777)',
  },
}), { name: 'VideoIframe' });

type Props = {
  title: string;
  src: string;
};

const VideoIframe = ({ title, src }: Props) => {
  const classes = useStyles();
  const containerRef = useRef<HTMLIFrameElement>(null);

  useEffect(
    () => {
      const container = containerRef.current;
      const onResize = () => {
        if (container) {
          const height = container.offsetWidth / 1.7777 + 3;
          container.style.height = `${height}px`;
        }
      };
      onResize();
      window.addEventListener('resize', onResize);

      return () => window.removeEventListener('resize', onResize);
    },
    [containerRef],
  );

  return (
    <iframe
      src={src}
      ref={containerRef}
      className={classes.frame}
      frameBorder="0"
      allow="autoplay; fullscreen"
      allowFullScreen
      title={title}
      scrolling="no"
    />
  );
};

export default VideoIframe;
